// Lib
import React from 'react';

// Components
import PageLoader from './PageLoader';

const INITIAL_PAGE_LOADER_OVERLAY_ID = 'initial-page-loader-overlay';

let pageLoaderRemoved = false;

export const removeInitialPageLoader = () => {
    if (pageLoaderRemoved) return;

    pageLoaderRemoved = !!document.getElementById(INITIAL_PAGE_LOADER_OVERLAY_ID);

    requestAnimationFrame(() => {
        // TODO - Remove this when client side page metrics are defined and measured
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.timeEnd('initialPageLoader');
        }

        const overlay = document.getElementById(INITIAL_PAGE_LOADER_OVERLAY_ID);
        overlay && overlay.parentNode.removeChild(overlay);
    });
};

const InitialPageLoader = (props) => (
    <div id={INITIAL_PAGE_LOADER_OVERLAY_ID} className="InitialPageLoader">
        <div className="fake-pwa-header" />
        <PageLoader />
    </div>
);

export default InitialPageLoader;
